const queue = []

class OCTRenderQueue {
  constructor () {}

  static push (item) {
    queue.push(item)
  }

  static flush () {
    while(queue.length) {
      (queue.shift())()
    }
  }
}

window.removeEventListener('scroll', OCTRenderQueue.flush)
window.addEventListener('scroll', OCTRenderQueue.flush)

window.removeEventListener('resize', OCTRenderQueue.flush)
window.addEventListener('resize', OCTRenderQueue.flush)

export default OCTRenderQueue
